<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="入职邀请"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  label-width="100px">
        <el-form-item label="职位信息" style="color:#4C71DB">  
           {{info.title}}
        </el-form-item>

        <el-form-item label="入职时间">  
         {{info.check_time}}
        </el-form-item>

        <el-form-item label="地址信息">
          {{info.address}}
        </el-form-item>



        <el-form-item label="联系方式" >
          {{info.check_mobile}}
        </el-form-item>


        <el-form-item label="入职通知">
          {{info.check_mark}}
        </el-form-item>

  

        <el-form-item label="入职" v-if="info.handle==2" >
          {{info.relation_status==10?'同意':'拒绝'}}
        </el-form-item>

        <el-form-item label="拒绝原因" v-if="info.handle==2&&info.relation_status==11" >
          {{info.user_check_reason}}
        </el-form-item>


        <el-form-item label="是否入职" v-if="info.handle==1&&isSend==2">
          <el-radio-group v-model="formData.relation_status" size="small">
            <el-radio label="10" border>同意</el-radio>
            <el-radio label="11" border>拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拒绝原因" v-if="info.handle==1&&formData.relation_status==11">
          <el-input 
            type="textarea" 
            v-model="formData.reason"  
            :rows="4"
            placeholder="输入拒绝原因"></el-input>
        </el-form-item>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit" v-if="info.handle==1&&isSend==2" >确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { auditInfo,auditUpdate,addressInfo,addressUpdate} from "@/api/chat/index";

import showPoint from "@/components/map/show-point.vue";

export default {
  components: {
    showPoint
  },

  inject:['sendHandleMsg'],

  data() {
    return {
      isSend:1,
      visible: false,
      formData:{
        enroll_id: "",
        reason:"",
        relation_status:"10",//状态10同意11拒绝
      },
      info: {
        title: "",
        job_id:"",
        handle:"",
        check_time: "",
        check_mobile: "",
        check_mark: "",
        address: "",
        lat: "",
        lng: "",
        enroll_id: "",
        reason:"",
        relation_status:"",//
        user_check_reason:"",
      }
    };
  },

 
  mounted() {

  },
  destroyed(){
  },
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();

      this.visible = false;

    },


    init(isSend,enroll_id) {
      this.visible = true;
      this.formData.enroll_id=enroll_id;
      this.isSend=isSend;
      this.initInfo();

    },

    initInfo(){
      var that = this;
      addressInfo({"enroll_id":that.formData.enroll_id}).then((response) => {
        if(response.code==200){
          that.info = response.data;

        }else{
          that.$message.warning(response.msg?response.msg:"获取信息失败");
        }
      });
    },

   
    
    submit(){
      var that=this;

     /*if(this.formData.relation_status==9){
        if(this.formData.reason==""){
          that.$message.warning("请输入拒绝理由");
          return;
        }

      }*/
      
      this.$refs["form"].validate((valid) => {
          if (valid) {
            addressUpdate(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
                that.visible = false;
                that.sendHandleMsg(that.formData.relation_status==10?22:23,'',that.formData.enroll_id,'','','','','');

              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
